export const limitValueLength = (maxLength) => (e) => {
  const value = e.target.value;
  const newValue = `${value}`.slice(0, maxLength);
  return parseInt(newValue)
};

export const limitFloatValueLength = (maxLength) => (e) => {
  const value = `${e.target.value}`.replace(/[^\.\,\d]/, '');
  return value.slice(0, maxLength);
};

export const floatValue = (e) => {
  const value = `${e.target.value}`.replace(/[^\.\,\d]/, '');
  return value;
}

export const limitIntegerValueLength = (maxLength) => (e) => {
  const value = `${e.target.value}`.replace(/[^\d]/, '');
  return value.slice(0, maxLength);
};

export const limitIntegerValueSignLength = (maxLength) => (e) => {
  const valueStr = `${e.target.value}`.replace(/\D+/, '').slice(0, maxLength);

  return (e.target.value.startsWith('-') || e.target.value.endsWith('-')) ? `${valueStr}-` : valueStr;
};

export const reverseSign = (stringValue) => {
  if (stringValue) {
    if (stringValue.endsWith('-')) return stringValue.split("").reverse().join("");
    else return stringValue
  }
}
export const reverseSignBack = (stringValue) => {
  if (stringValue) {
    if (stringValue.startsWith('-')) return stringValue.split("").reverse().join("");
    else return stringValue
  }
}

export const limitValueRange = (maxLength, min, max) => (e) => {
  const value = `${e.target.value}`.replace(/[^0-9\.\,]/g, '');
  if (value < min) {
    return min;
  } else if (value > max) {
    return max;
  } else {
    return value.slice(0, maxLength) || ''
  }
};

export const limitValueRangeInteger = (maxLength, min, max) => (e) => {
  const value = `${e.target.value}`.replace(/[^0-9]/g, '');
  if (value < min) {
    return min;
  } else if (value > max) {
    return max;
  } else {
    return value.slice(0, maxLength) || '0'
  }
};

export const limitValueRangeFloat = (maxLength, min, max) => (e) => {
  const value = `${e.target.value}`.replace(/[^\.\,\d]/, '');
  if (value < min) {
    return min;
  } else if (value > max) {
    return max;
  } else {
    return value.slice(0, maxLength) || ''
  }
};

export const addComaRoundDecimals = (numb) => {
  const string = numb !== null ? String(Math.round(numb)) : '';
  const numbValue = string.replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,');
  return numbValue
};

export const limitDataLength = (maxLength) => (val) => {
  const value = val !== null ? `${val}`.replace(/[^\.\,\d]/, '') : '';
  return value.slice(0, maxLength);
};

export const divideThousandsInteger = value => {
  if (value) {
    let parts = value.toString().replace(/[^\d]/, '').split(".");
    parts[0] = parts[0].startsWith('0')
      ? ''
      : parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return parts.join(".");
  }
};

export const formatStringToNumber = e => {
  const stringValue = (e.target.value).replace(/[\s,%]/g, '');

  return stringValue ? stringValue : '';
};
